import { isBlockedOffer } from './offersHelpers';
import { displayCurrency } from '../../../utils/DisplayCurrency';

const initialState = {
    ready: false,
    offers: []
};

export default function (
    state = initialState,
    action: { type: string; payload: any }
) {
    switch (action.type) {
        case 'OFFERS_PAGE_READY': {
            const {
                offersResponse: { offers },
                isPartnerCustomer
            } = action.payload;

            const offerData = offers.map((offer: any) => {
                let singleOffer: any = {
                    productType: parseOfferType(offer),
                    offerId: offer.offer_id,
                    offerType: offer.offer_type,
                    amount: displayCurrency(offer.max_amount),
                    //
                    feePercentage: offer?.fee_percentage
                        ? offer?.fee_percentage
                        : null,
                    // MCA don't have interest rates, so we check
                    interestRate:
                        offer.interest_rate !== undefined
                            ? (offer.interest_rate * 100).toFixed(2)
                            : null,
                    showProbabilityOfOffer:
                        offer.probability_of_offer &&
                        offer.probability_of_offer ===
                            'high_probability_of_offer'
                };

                if (offer.sweep) {
                    singleOffer = {
                        ...singleOffer,
                        sweep: {
                            min: offer.sweep.percentage_min.toString(),
                            max: offer.sweep.percentage_max.toString()
                        }
                    };
                }
                return singleOffer;
            });

            return {
                ...state,
                ready: true,
                offers: offerData,
                isPartnerCustomer
            };
        }

        default:
            return state;
    }
}

const parseOfferType = (offer: any) => {
    if (offer.product_type === 'merchant_cash_advance') return 'rbl';

    if (
        offer.product_type === 'credit_facility' &&
        offer.offer_type === 'confirmed'
    )
        return 'lightning';

    if (offer.product_type === 'credit_facility' && isBlockedOffer(offer))
        return 'lightningBlocked';

    if (
        offer.product_type === 'credit_facility' &&
        offer.duration.amount <= 365
    )
        return 'flexi12';

    if (
        offer.product_type === 'flexi24' &&
        offer.duration.amount >= 730 &&
        offer.offer_type === 'confirmed'
    )
        return 'flexi24Auto';

    if (
        offer.product_type === 'flexi24' &&
        offer.duration.amount >= 730 &&
        isBlockedOffer(offer)
    )
        return 'flexi24AutoBlocked';

    if (offer.product_type === 'flexi24' && offer.duration.amount >= 730)
        return 'flexi24';

    return 'unknown';
};
